import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6ae7babc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "MapsComponent__permissions"
};
var _hoisted_2 = {
  "class": "MapsComponent__container"
};
var _hoisted_3 = {
  key: 0,
  "class": "MapsComponent__instructions"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "colorized"
  }, "resturaunts", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    "class": "MapsComponent__map"
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createTextVNode("Map Requires Location Permissions "), _createVNode(_component_ButtonBasic, {
    "class": "MapsComponent__permissions-button",
    label: "Update Permissions Now",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowPermissionsScreen', true);
    })
  })], 512), [[_vShow, _ctx.$store.state.permission_location == false]]), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    ref: "navigateButton",
    "class": "navigate-button",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.openDirectionsExternally && _ctx.openDirectionsExternally.apply(_ctx, arguments);
    }),
    hidden: ""
  }, "Navigate Here", 512), _createElementVNode("button", {
    ref: "startNavigationButton",
    "class": "start-navigation-button",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.startNavigation && _ctx.startNavigation.apply(_ctx, arguments);
    }),
    hidden: ""
  }, "Start Navigation", 512), _createElementVNode("button", {
    ref: "openExternallyButton",
    "class": "open-externally-button",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.openDirectionsExternally && _ctx.openDirectionsExternally.apply(_ctx, arguments);
    }),
    hidden: ""
  }, "Open Externally", 512), true || _ctx.showMapHint ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode("Use your voice to look for places near you. Simply Say "), _createElementVNode("b", null, [_createTextVNode("\"" + _toDisplayString(_ctx.searchWordExample) + " ", 1), _hoisted_4, _createTextVNode(" near me\"")])])) : _createCommentVNode("", true), _hoisted_5])]);
}